import { ATLFlightInfo } from './types'

const host = location.host.endsWith('flightview.com') ? location.host : 'tracker.flightview.com'

export async function getFlights (airportCode: string, direction: 'Departures' | 'Arrivals', includeEstimates: boolean = false): Promise<ATLFlightInfo[]> {
  // when noest=1, a different fvXML instance that estimate the position of the planes is used for flights that don't have position available
  const response = await fetch(`https://${host}/FVAccess3/tools/dhtml/proxy/fidsjson.aspx?apt=${airportCode}&dir=${direction}${includeEstimates ? '' : '&noest=1'}&excs=1&cb=${Date.now()}`, {
    headers: {
      Accept: 'application/json'
    }
  })
  if (response.status !== 200) {
    throw new Error(`Cannot retrieve ${direction} flights for the moment: Status Code ${response.status}`)
  }
  const flights: ATLFlightInfo[] = await response.json()
  if (flights) {
    for (const flight of flights) {
      enrich(flight)
    }
  }
  return flights
}

function enrich (flight: ATLFlightInfo) {
  try {
    flight.id = `${flight.airlineCode}${flight.flightNumber}:${flight.departureAirportCode}:${flight.departureDate}:${flight.departureTimeUtc.substring(0, 5).replace(':', '')}`
    // temp workaround until the api returns number natively
    if (flight.longitude) {
      flight.longitude = parseFloat(flight.longitude.toString())
    }
    if (flight.latitude) {
      flight.latitude = parseFloat(flight.latitude.toString())
    }
    if (flight.orientation) {
      flight.orientation = parseFloat(flight.orientation.toString())
    }
  } catch (e) {
    console.warn('Cannot create id')
  }
}
